import { Dispatch, SetStateAction } from 'react';

export enum ACTION_FILTERS {
  ACHIEVEMENT = 'Achievement',
  APPOINTMENT = 'Appointment',
  APP_OPEN = 'App Open',
  APP_UNINSTALL = 'App Uninstall',
  CHALLENGE = 'Challenge',
  DRUG_SCREEN = 'Drug Screen',
  ENGAGEMENT_ACTIVITY = 'Engagement Activity',
  EPISODE_OF_CARE = 'Episode of Care',
  LOG_IN = 'Log In',
  LOG_OUT = 'Log Out',
  MESSAGE = 'Message',
  MISSION = 'Mission',
  NOTE = 'Note',
  PERSON_MERGE = 'Person Merge',
  PHASE = 'Phase',
  PROGRAM_QUALIFICATION = 'Program Qualification',
  REFERRAL = 'Referral',
  SIGN_UP = 'Sign Up',
  SURVEY = 'Survey',
  TASK = 'Task'
}

export interface TimelineFilters {
  object_id: string;
  action: string[];
  created_at__gte: string; // start at
  created_at__lte: string; // end at
  search: string;
}

export interface Props {
  activeFilters: Partial<TimelineFilters>;
  setFilters: Dispatch<SetStateAction<Partial<TimelineFilters>>>;
}
